export default __webpack_public_path__ + "static/media/20-1.c519cc99.mp3";